import { ThemePicState } from 'components/pages/EventUpdatePage';
import React from 'react';

type ThemeContext = {
  themePic: ThemePicState;
  setThemePic: any;
};

export const EventUpdatePageContext = React.createContext<ThemeContext>(null as any);
